<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div
        class="emp-button btn-align text-right"
        v-if="
          user &&
          (user.type == 'MANAGER' ||
            (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
        "
      >
        <button
          type="button"
          data-toggle="modal"
          data-target="#creat-employee"
          class="btn btn-outline-primary"
        >
          Create New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp p-0 bg-transparent">
        <div class="main-box hour-head-info">
          <div class="text-wrapper">
            <div class="hour-list">
              <div class="list-col">
                <span class="lable-text">Name</span>
                <strong class="col-blue">{{ employeeId.name }}</strong>
              </div>

              <div class="list-col" style="width: 140px;">
                <span class="lable-text">Month</span>
                <div class="form-group">
                  <div class="">
                    <select
                      class="form-select form-control"
                      id="selMonth"
                      name="selMonth"
                      v-model="selectedMonth"
                      @change="onChange(selectedMonth)"
                    >
                      <option
                        v-for="(month, index) in months"
                        :key="index"
                        :value="index + 1"
                        v-if="shouldShowMonth(index)"
                      >
                        {{ month }}
                      </option>
                    </select>

                  </div>
                </div>
              </div>

              <!-- years -->
              <div class="list-col" style="width: 160px;">
                <span class="lable-text">Year</span>
                <div class="form-group">
                  <div class="">
                    <select v-model="selectedYear" id="selYear" name="selYear" class="form-select form-control" @change="onYearChange(selectedYear)">
                      <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="table-scroll">
          <table class="table">
            <thead class="table-head">
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Time</th>
              <th scope="col">Attendance</th>
              <th scope="col">Attendance Hours</th>
              <th scope="col">Hours</th>
              <th scope="col">Hourly Rate</th>
              <th scope="col">Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-show="loadingSpin">
              <clip-loader
                :loading="loadingSpin"
                :size="size"
                :color="spinnerColor"
              ></clip-loader>
            </tr>
            <tr v-show="hoursNotFound && loadingSpin == false">
              <td :colspan="6" class="text-center">No data found</td>
            </tr>
            <tr  v-for="(schedule) in newEmpAtt.schedules" v-if="newEmpAtt.schedules.length > 0 && schedule.attendances.length > 0"
                 :key="schedule.id" :class="'shiftRowAttendSal_'+schedule.date">

              <td>
                {{ moment(schedule.date).format("DD-MMM-YYYY") }}
              </td>
              <td class="cardHeadCus">
                {{moment(schedule.start_time, "HH:mm:ss").format("HH:mm")}} - {{moment(schedule.end_time, "HH:mm:ss").format("HH:mm" )}}
                <i :id="schedule.id" @click="editShift(schedule)"
                   v-if="
        user &&
        (user.type == 'MANAGER' ||
          (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
      "
                   class="fa fa-edit fa-remove-custom"></i>
                <div v-if="schedule.id===isUpdateShiftId">
                  <input type="text"  v-model="schedule.start_time" placeholder="Start" style="width: 43px;">
                  <input type="text" placeholder="End" v-model="schedule.end_time" style="width: 43px;">
<!--                  <input type="text" placeholder="End" style="width: 43px;">-->
                  <button style="width: 43px;" @click="updateShiftTime(schedule)">save</button>
                </div>
              </td>
              <td v-if="schedule.attendances && schedule.attendances.length > 0">
                <div v-for="attendance in schedule.attendances" :key="attendance.id">
                    {{ moment(attendance.punch_in_time).format("HH:mm") }} -
                    <span v-if="attendance.punch_out_time === null">--:--</span>
                    <span v-else>{{ moment(attendance.punch_out_time).format("HH:mm") }}</span>
                </div>
            </td>
            <td v-else>--</td>

            <td v-if="schedule.attendances && schedule.attendances.length > 0">
                <div v-for="attendance in schedule.attendances" :key="attendance.id+'-'+attendance.schedule_id">
                    {{ getHoursByAttendanceAndShift(attendance) }}
                </div>
            </td>
            <td v-else>--</td>

            <td v-if="schedule.attendances && schedule.attendances.length > 0">
                <div v-for="attendance in schedule.attendances" :key="attendance.id+'-'+attendance.punch_in_time">
                    {{ getHoursByAttendanceAndShift2(attendance, schedule) }}
                </div>
            </td>
            <td v-else>--</td>

            <td>{{ newEmpAtt.hourlyRate.toFixed(2) }}</td>

            <td v-if="schedule.attendances && schedule.attendances.length > 0">
                <div v-for="attendance in schedule.attendances" :key="attendance.id+'-'+attendance.punch_in_out">
<!--                    {{  (newEmpAtt.hourlyRate * convertTimeFormatIntoHoursMints( getHoursByAttendanceAndShift2(attendance, schedule))).toFixed(2) }}-->
                  {{ (calculateSalWithMinutes(newEmpAtt.hourlyRate,getHoursByAttendanceAndShift2(attendance, schedule))).toFixed(2) }}
                </div>
            </td>
            <td v-else>--</td>
            </tr>
            <tr>
              <td colspan="4">
                 Worked Day: {{countRecordsWithAttendances}}
                <br>
                 Shift Days: {{totalShiftDays}}
              </td>
              <td class="text-center">{{totalShiftTIme}}</td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center">{{totalAttendanceHours}}</td>
              <td class="text-center"></td>
              <td class="text-center">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{totalActualHours}}</td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center">
                  <span>
                   <b>{{ grossSalary().toFixed(2) }}</b>
                  </span>
              </td>
              <td class="text-center"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
        </div>
        <div v-if="
        user &&
        (user.type == 'MANAGER' ||
          (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
      ">
          <h5><b>This Month Salary:</b> {{ currentSalary }}</h5>
          <h5>
              <b v-if="isWithoutAttendancePayableSalary===true">Without Attendance Payable Salary:</b> <b v-else>This Month Payable Salary</b>
                 {{ payable }}

          </h5>
        </div>
        <br/>
        <div v-if="
        user &&
        (user.type == 'MANAGER' ||
          (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
      ">

          <div class="row mb-5" v-if="idEdit">
            <input type="hidden" name="editable" v-model="editableId">
            <div class="col-md-3">
              <select
                class="form-select form-control"
                name="salaryComponent"
                required
                v-model="selectedComponent"
                @change="handleSelectChange" disabled
              >
                <option value="" disabled selected>select component</option>
                <option
                  :value="component.name"
                  v-for="component in salaryComponents"
                  :key="component.id"
                >
                  {{ component.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                class="form-select form-control"
                id="dc"
                name="dc"
                required
                v-model="selectedDC"
              >
                <option value="Credit" selected>Credit</option>
                <option value="Debit">Debit</option>
              </select>
            </div>
            <div class="col-md-3">
              <input
                type="text"
                class="form-control"
                id="amount"
                name="amount"
                placeholder="amount"
                v-model="amount"
                required
              />
            </div>
          </div>

          <div class="row mb-5" v-else>
            <div class="col-md-3">
              <select
                class="form-select form-control"
                id="salaryComponent"
                name="salaryComponent"
                required
                v-model="selectedComponent"
                @change="handleSelectChange"
              >
                <option value="" disabled selected>Select a Component</option>
                <option
                  :value="component.name"
                  v-for="component in salaryComponents"
                  :key="component.id"
                  class="text-capitalize">
                  {{ component.name }}
                </option>
                <option disabled>---------------------------</option>
                <option style="background-color: #d9d9d4;" value="#addEntryModel">+ Add New</option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                class="form-select form-control"
                id="dc"
                name="dc"
                required
                v-model="selectedDC"
              >
                <option value="Credit" selected>Credit</option>
                <option value="Debit">Debit</option>
              </select>
            </div>
            <div class="col-md-3">
              <input
                type="text"
                class="form-control"
                id="amount"
                name="amount"
                placeholder="Amount"
                v-model="amount"
                required
              />
            </div>
            <div class="col-md-3">
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="saveSalaryComponentCalculation"
              >
                Add
              </button>
            </div>
          </div>

        </div>
        <div class="table-scroll col-md-9 mt-5" style="margin-bottom: 50px" v-if="
        user &&
        (user.type == 'MANAGER' ||
          (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))
      ">
          <table class="table">
            <thead class="table-head">
            <tr>
              <th scope="col">Salary Component</th>
              <th scope="col">Credit/Debit</th>
              <th scope="col">Amount</th>
              <th scope="col">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-show="loadingSpin">
              <clip-loader
                :loading="loadingSpin"
                :size="size"
                :color="spinnerColor"
              ></clip-loader>
            </tr>
            <tr v-show="calculationNotFound && loadingSpin == false">
              <td :colspan="6" class="text-center">No data found</td>
            </tr>
            <tr
              v-for="calculation in salaryComponentCalculations" v-if="salaryComponentCalculations.length>0"
              :key="calculation.id"
            >
              <td>{{ calculation.salary_component }}</td>
              <td>{{ calculation.type }}</td>
              <td>{{ calculation.amount.toFixed(2) }}</td>
              <td>
                <div
                  class="actionBtn"
                  v-if="
                      user &&
                      (user.type == 'MANAGER' ||
                        (user.type == 'EMPLOYEE' &&
                          user.managerAccess == 'yes'))
                    "
                >
                  <button class="btn btn-danger" @click="editSalaryCalculation(calculation)">Edit</button>
                  <button
                    class="btn btn-danger"
                    @click="deleteSalaryCalculation(calculation)"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div
          class="actionBtn"
          v-if="user && (user.type == 'MANAGER' || (user.type == 'EMPLOYEE' && user.managerAccess == 'yes'))" >
          <button class="btn btn-sm btn-success" @click.prevent="updateSalaryComponentCalculation" v-if="idEdit">
            Update
          </button>
          <button class="btn btn-sm btn-primary" @click.prevent="cancelUpdate" v-if="idEdit">
            Cancel
          </button>
          <button class="btn btn-sm btn-success" @click.prevent="saveSalary" v-else>
            Save
          </button>
          <!-- Lock -->
              <span  class="" >
                <a v-on:click="lockAndSendEmail()" class="btn btn-warning"
                ><clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
                  Lock & Send Email</a>
              </span>
        </div>
        <div
          class="modal fade add-absence-model"
          id="addEntryModel"
          tabindex="-1"
          role="dialog"
          aria-labelledby="add-absenceLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  <h5>Add New</h5>
                </div>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="ico-cross"></span>
                </button>
              </div>

              <div class="modal-body">
                <form>
                  <div class="form-group row">
                    <div class="col">
                      <label for="name" class="col-form-label modelbody-name">Name:</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter a Entry"
                        v-model="name2"
                        @keydown.enter.prevent="addName"
                        @input="validateName"
                        class="form-control"
                      />
                    </div>
                    <div class="col-auto align-self-end">
                      <button
                        @click.prevent="addName"
                        class="btn btn-outline-dark"
                      >
                        <span class="plus-icon">+</span>
                      </button>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col text-danger" v-if="nameError">
                      Only alphabet characters are allowed
                    </div>
                    <div class="col text-danger" v-if="duplicateError">
                      Name already exists
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col">
                      <span v-for="(n, index) of name" :key="index">
                        <span class="name-box">{{ n }} <label for="remove" class="remove-label"
                                                              @click="removeName(n, index)"><span class="close-icon"><i
                          class="gg-close-o"></i></span></label></span>
                      </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col" v-if="name.length>0">
                      <button
                        @click.prevent="saveSalaryComponents"
                        class="btn btn-outline-primary btn-block"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div
                class="table-scroll col-md-12 mt-10"
                style="margin-bottom: 50px"
              >
                <table class="table">
                  <thead class="table-head">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-show="loadingSpin">
                    <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
                  </tr>
                  <tr v-show="!loadingSpin && salaryComponents.length === 0">
                    <td :colspan="3" class="text-center">No data found</td>
                  </tr>
                  <tr v-for="(component,index) in salaryComponents" :key="component.id">
                    <td>{{ index + 1 }}</td>
                    <td class="text-capitalize">{{ component.name }}</td>
                    <td>
                      <div class="actionBtn"
                           v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                        <button class="btn btn-danger" @click="deleteSalaryComponent(component.id)"><i
                          class="fa fa-trash"></i></button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-if="user &&(user.type == 'EMPLOYEE')">
          <div class="row" v-if="salaryComponentCalculations.length>0">
            <div class="col-md-6"></div> <!-- Empty column to offset -->
            <div class="col-md-6 mt-5" style="margin-bottom: 50px">
              <table class="table">
                <tbody>
                <tr v-show="loadingSpin">
                  <clip-loader
                    :loading="loadingSpin"
                    :size="size"
                    :color="spinnerColor"
                  ></clip-loader>
                </tr>
                <tr v-show="calculationNotFound && loadingSpin == false">
                  <td :colspan="6" class="text-center">No data found</td>
                </tr>
                <tr
                  v-for="calculation in salaryComponentCalculations" v-if="salaryComponentCalculations.length>0"
                  :key="calculation.id"
                >
                  <td>{{ calculation.salary_component }}</td>
                  <td>{{ calculation.type }}</td>
                  <td>{{
                      calculation.type === 'Debit' ? '-' + calculation.amount.toFixed(2) : calculation.amount.toFixed(2)
                    }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-between" style="margin-top:-25px">
            <div></div> <!-- Empty column to push the <h5> to the right side -->
            <h5>
              <b>Payable:</b> {{ payable }}

            </h5>
          </div>
        </div>
      </div>
      <createEmployeeModal></createEmployeeModal>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import employeeSidebar from "../Employees/employeeSidebar";
import createEmployeeModal from "../Employees/createEmployeeModal";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "employeeBalance",
  components: {
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
    ClipLoader,
  },
  data() {
    return {
      sizeMain: '35px',
      loadingSpinMain: false,
      loading: false,
      selectedMonth:  new Date().getMonth() + 1, // Set the selected month to the previous month
      employeeId: this.$store.getters.getEmployeeProfileId,
      employee: [],
      selectedCompany: this.$store.getters.getSelectedCompany,
      range: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      ],
      employee_name: "",
      from_date: "",
      to_date: "",
      empId: "",
      totalhours: 0,

      totalMinutes: 0,
      countofDays: 0,
      form: {
        from_date: "",
        to_date: "",
        employee_id: "",
      },
      empAttend: [],
      allAttendances: [],
      startDate: "",
      endDate: "",
      diff: [],
      size: "25px",
      spinnerColor: "#00779C",
      loadingSpin: false,
      hoursNotFound: false,
      calculationNotFound: false,
      map: null,
      allLocations: [],
      user: this.$store.getters.getUser,
      totalBalance: 0,
      employeeLeaves: [],
      name: [],
      name2: "",
      isNameValid: true,
      salaryComponents: [],
      duplicateAttendance: [],
      salaryComponentCalculations: [],
      duplicateError: false,
      nameError: false,
      balance: 0,
      selectedComponent: "",
      selectedDC: "Credit",
      amount: 0,
      payable: null,
      idEdit: false,
      editableId: null,
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      salaryComponentCalculationsSum: 0,
      fullDayLeaves: [],
      fullDayLeavesBalance: 0,
      newEmpAtt: [],
      grossPay: 0,
      selectedYear: new Date().getFullYear(), // Default to current year
      numPreviousYears: 10, // Number of previous years to include in the dropdown
      fullMonthShiftTIme: 0,
      totalShiftTIme: 0,
      isWithoutAttendancePayableSalary: false,
      withoutAttendancePayableSalary: 0,
      totalShiftDays: 0,
      currentSalary: 0, // Number of previous years to include in the dropdown
      updateStartTime:'0:0',
      isUpdateShiftId:'',

    };
  },
  computed: {
    nextMonth() {
      const currentMonth = new Date().getMonth();
      if(this.user &&
        (this.user.type == 'MANAGER' ||
          (this.user.type == 'EMPLOYEE' && this.user.managerAccess == 'yes'))){
        return (currentMonth) % 12; // Get index of next month, wrapping around to January if current month is December
      }else{
        return (currentMonth-1) % 12; // Get index of next month, wrapping around to January if current month is December
      }

    },
    countRecordsWithAttendances() {
      if (Object.keys(this.newEmpAtt).length === 0) {
        return 0;
      } else {
         this.totalShiftDays=  this.newEmpAtt.schedules?.filter(schedule => schedule.attendances).length;
         return this.newEmpAtt.schedules?.filter(schedule => schedule.attendances && schedule.attendances.length > 0).length;
      }
    },
    totalAttendanceHours() {
        let totalMinutes = 0;

        // Sum up the total minutes
        this.newEmpAtt.schedules?.forEach(schedule => {
            schedule.attendances.forEach(attendance => {
                const [hours, minutes] = this.getHoursByAttendanceAndShift(attendance).split(":").map(Number);
                totalMinutes += hours * 60 + minutes; // Convert hours to minutes and add to total
            });
        });
        // Calculate total hours and remaining minutes
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        // Format the total hours and remaining minutes
        const formattedTotal = `${totalHours}:${remainingMinutes.toString().padStart(2, "0")}`;
        return formattedTotal;
    },
    totalActualHours() {
        let totalMinutes = 0;
        let totalShiftTIme = 0;
        let fullMonthShiftTIme = 0;
        // Sum up the total minutes
        this.newEmpAtt.schedules?.forEach(schedule => {
            schedule.attendances.forEach(attendance => {
                const [hours, minutes] = this.getHoursByAttendanceAndShift2(attendance, schedule).split(":").map(Number);
                totalMinutes += hours * 60 + minutes; // Convert hours to minutes and add to total
            });
            if(schedule.attendances.length>0){
              const [hour, minute]=this.shiftTotalHours(schedule).split(":").map(Number)
              totalShiftTIme+= hour* 60 + minute;
            }
          if(schedule){
            const [fhour, fminute]=this.shiftTotalHours(schedule).split(":").map(Number)
           // console.log(schedule.date,'hour: ',fhour,'mint',fminute);
            fullMonthShiftTIme+= fhour* 60 + fminute;
          }
        });
        console.log(totalMinutes,'totalMinutes');
        this.totalShiftTIme=this.timeFormat(totalShiftTIme);
        this.fullMonthShiftTIme=this.timeFormat(fullMonthShiftTIme);
        // Calculate total hours and remaining minutes
        const formattedTotal = this.timeFormat(totalMinutes);
        return formattedTotal;
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - this.numPreviousYears;
      const endYear = currentYear;
      return Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    }
  },
  mounted() {
    this.$root.$emit("activeCompoClick");
    this.employee_id = this.$route.params.id || "";
     this.selectedMonth= this.selectedMonth;
    if(this.user && ((this.user.type == 'EMPLOYEE' && this.user.managerAccess == 'no'))){
      this.selectedMonth = this.selectedMonth === 1 ? 12 : this.selectedMonth - 1; // Calculate previous month
    }



    this.setDates();
    this.getEmployeeAttendanceWithSalary();
    this.getSalaryComponents();
    this.getSalaryComponentCalculations();
    // this.getSalaryCalculation();
  },
  methods: {
    calculateSalWithMinutes(hourlyRate,hoursMint){

      // console.log(hourlyRate,hoursMint,'hourlyRate,hoursMint')
      //var hoursMint='8.54';
      var minutesRate=hourlyRate/60
      const [hours, minutes] = hoursMint.split(':').map(Number);
      // Convert hours and minutes to total minutes
      const mint= (hours * 60) + minutes;
      console.log(mint,'mint mint');
      return mint*minutesRate;
    },
    editShift(schedule){
      this.isUpdateShiftId = schedule.id;
    },
    updateShiftTime(schedule){
      var data = {
        id: schedule.id,
        date: schedule.date,
        start_time: schedule.start_time,
        end_time: schedule.end_time,
        company_id: schedule.company_id,
      };
      this.$axios({
        method: "POST",
        data: data,
        url: this.$UpdateShift,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.status == 200) {
            this.isUpdateShiftId = '';
            this.getEmployeeAttendanceWithSalary();
            this.getSalaryComponentCalculations();
            $root.$toast.success('Updated Successfully');
          }
        });
    },
    lockAndSendEmail(){
      if(confirm('Are you sure that you want to lock this salary?')){
        if(this.sumAllAmount !== 0) {
          if (this.is_lock !== 0) {
            this.loading = true;
            var data = {
              employee_id: this.employeeId.id,
              company_id: this.selectedCompany.id,
              selectedMonth: this.selectedMonth,
              selectedYear: this.selectedYear,
            };
            this.$axios({
              method: "POST",
              data: data,
              url: this.$CalculatedSalaryLock,
              headers: this.getAuthHeader(),
            }).then((res) => {
              if (res.data.status == 200) {
                this.loading = false;
                $root.$toast.success('Salary saved successfully!');
              }
            });
          } else {
            $root.$toast.success("This salary locked already!");
          }
        }
      }
    },
    convertTimeFormatIntoHoursMints(calHours){
     // console.log(calHours,'calHours');
     // const calHours = '2:30';
      const [hours, minutes] = calHours.split(':').map(Number);
      const formattedHours = hours + (minutes / 100); // This will format it as 2.30
     // console.log(formattedHours,'formattedHours');
      return  formattedHours ;
    },
    timeFormat(totalMinutes){
      // Calculate total hours and remaining minutes
      const totalHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      // Format the total hours and remaining minutes
      return `${totalHours}:${remainingMinutes.toString().padStart(2, "0")}`;
    },
    addName() {
      if (!this.nameError && !this.duplicateError && this.name2.trim() !== "") {
        this.name.unshift(this.name2);
        this.name2 = "";
      }
    },
    removeName(name, index) {
      // Remove the name only when clicking on the "x" label
      const removeConfirmation = confirm(
        `Are you sure you want to remove ${name}?`
      );
      if (removeConfirmation) {
        this.name.splice(index, 1);
      }
    },
    handleSelectChange(event) {
      const selectedValue = event.target.value;
      if (selectedValue === '#addEntryModel') {
        this.name2 = '';
        this.nameError = false;
        this.duplicateError = false;
        this.selectedComponent = '';
        event.target.selectedIndex = 0;
        $('#addEntryModel').modal('show');
      }
    },

    saveSalaryComponents() {
      if (this.name) {
        this.$axios({
          method: "POST",
          url: this.$saveSalaryComponents,
          headers: this.getAuthHeader(),
          data: {
            data: this.name,
            company_id: this.selectedCompany.id,
          },
        }).then((res) => {
          $root.$toast.success(res.data.message);
          // Hide the modal
          document.querySelector(".add-absence-model").classList.remove("show");
          document
            .querySelector(".add-absence-model")
            .setAttribute("aria-hidden", "true");
          const modalBackdrop = document.querySelector(".modal-backdrop");
          if (modalBackdrop) {
            modalBackdrop.remove();
          }
          this.name = [];
          this.getSalaryComponents();
          $('#addEntryModel').modal('hide');
        });
      }
    },

    getHoursByAttendanceAndShift(attendance) {
      const punchInTime = new Date(attendance.punch_in_time);
      let punchOutTime = new Date(attendance.punch_out_time);
      const punchOutDateTime = moment(attendance.punch_out_time, "YYYY-MM-DD HH:mm:ss");
      const timeDifference = punchOutTime - punchInTime;
      // Convert milliseconds to hours and minutes
      const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
      const totalMinutes = Math.round(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      // Combine hours and minutes
      // let punchInOutTotalHours = totalHours + totalMinutes / 100; cv
      let punchInOutTotalHours = totalHours + (totalMinutes / 60);

      // Extract the integer part (hours) and decimal part (minutes)
      let hours = Math.floor(punchInOutTotalHours);
      let minutes = Math.round((punchInOutTotalHours - hours) * 60);

      // Format the minutes to have leading zero if needed
      let formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // Combine hours and minutes in the desired format
      let formattedTime = `${hours}:${formattedMinutes}`;
      if (attendance.punch_out_time === null) {
          const now = new Date();
          const punchInTime = new Date(attendance.punch_in_time);

          // Set current date for both punch-in and current time
          const currentDateTime = new Date();
          punchInTime.setFullYear(currentDateTime.getFullYear());
          punchInTime.setMonth(currentDateTime.getMonth());
          punchInTime.setDate(currentDateTime.getDate());

          const timeDifference = now - punchInTime;
          const totalMinutes = timeDifference / (1000 * 60); // Convert milliseconds to minutes
          const hours = Math.floor(totalMinutes / 60);
          const minutes = Math.floor(totalMinutes % 60);
          const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
          return formattedTime
      }
      return formattedTime;
    },

    getHoursByAttendanceAndShift2(attendance,schedule) {

      const punchInTime = new Date(attendance.punch_in_time);
      let punchOutTime = new Date(attendance.punch_out_time);
      const punchOutDateTime = moment(attendance.punch_out_time, "YYYY-MM-DD HH:mm:ss");
      const shiftDateTime = moment(schedule.date + ' ' + schedule.end_time, "YYYY-MM-DD HH:mm:ss");

      // if (punchOutDateTime.isAfter(shiftDateTime)) {
      //   punchOutTime = new Date(shiftDateTime);
      //
      // }
      const timeDifference = punchOutTime - punchInTime;
      // Convert milliseconds to hours and minutes
      const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
      const totalMinutes = Math.round(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      // Combine hours and minutes
      // let punchInOutTotalHours = totalHours + totalMinutes / 100; cv
      let punchInOutTotalHours = totalHours + (totalMinutes / 60);

      // Extract the integer part (hours) and decimal part (minutes)
      let hours = Math.floor(punchInOutTotalHours);
      let minutes = Math.round((punchInOutTotalHours - hours) * 60);
      // Format the minutes to have leading zero if needed
      let formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // Combine hours and minutes in the desired format
      let formattedTime = `${hours}:${formattedMinutes}`;
      if (attendance.punch_out_time === null) {
          const now = new Date();
          const punchInTime = new Date(attendance.punch_in_time);
          // Set current date for both punch-in and current time
          const currentDateTime = new Date();
          punchInTime.setFullYear(currentDateTime.getFullYear());
          punchInTime.setMonth(currentDateTime.getMonth());
          punchInTime.setDate(currentDateTime.getDate());
          const timeDifference = now - punchInTime;
          const totalMinutes = timeDifference / (1000 * 60); // Convert milliseconds to minutes
          const hours = Math.floor(totalMinutes / 60);
          const minutes = Math.floor(totalMinutes % 60);
          const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
          return formattedTime
      }
      //start im
      // Get the shift hours including fractional hours
      const [startHour, startMinute] = schedule.start_time
        .split(":")
        .map(Number);
      const [endHour, endMinute] = schedule.end_time
        .split(":")
        .map(Number);
// Convert hours and minutes to milliseconds
      const startTimeMillis = (startHour * 60 + startMinute) * 60 * 1000;
      const endTimeMillis = (endHour * 60 + endMinute) * 60 * 1000;
      const shiftTimeDifference = endTimeMillis - startTimeMillis;
      const shiftTotalHours = shiftTimeDifference / (1000 * 60 * 60); // Total hours including fractions
// Calculate the total hours and minutes separately
      let totalShiftHours = Math.floor(shiftTotalHours); // Whole hours
      let totalShiftMinutes = Math.round(
        (shiftTotalHours - totalShiftHours) * 60
      ); // Remaining minutes

// Format shift total hours and minutes
      const formattedShiftTotalHours = totalShiftHours.toString().padStart(2, '0');
      const formattedShiftTotalMinutes = totalShiftMinutes.toString().padStart(2, '0');

      let shiftTotal = `${formattedShiftTotalHours}:${formattedShiftTotalMinutes}`;
      if(punchInOutTotalHours > totalShiftHours){
        return shiftTotal;
      }//shiftRowAttendSal_
      if(punchInOutTotalHours<totalShiftHours){
        $('.shiftRowAttendSal_'+schedule.date).css('background','rgb(223 207 13 / 40%)')
      }

      //end im
      return formattedTime;
    },


    shiftTotalHours(schedule){
      const [startHour, startMinute] = schedule.start_time
        .split(":")
        .map(Number);
      const [endHour, endMinute] = schedule.end_time
        .split(":")
        .map(Number);
// Convert hours and minutes to milliseconds
      const startTimeMillis = (startHour * 60 + startMinute) * 60 * 1000;
      const endTimeMillis = (endHour * 60 + endMinute) * 60 * 1000;

      const shiftTimeDifference = endTimeMillis - startTimeMillis;
      const shiftTotalHours = shiftTimeDifference / (1000 * 60 * 60); // Total hours including fractions

// Calculate the total hours and minutes separately
      let totalShiftHours = Math.floor(shiftTotalHours); // Whole hours
      let totalShiftMinutes = Math.round(
        (shiftTotalHours - totalShiftHours) * 60
      ); // Remaining minutes

// Format shift total hours and minutes
      const formattedShiftTotalHours = totalShiftHours.toString().padStart(2, '0');
      const formattedShiftTotalMinutes = totalShiftMinutes.toString().padStart(2, '0');

      return `${formattedShiftTotalHours}:${formattedShiftTotalMinutes}`;
    },

    saveSalary() {
      if (this.amount) {
        this.payable =
          this.selectedDC === "Credit"
            ? parseFloat(this.payable) + parseFloat(this.amount)
            : parseFloat(this.payable) - parseFloat(this.amount);
      }
      if (this.payable == 0.00) {
        $root.$toast.error("Payable must not be equal to 0.00.");
        return;
      }
      this.$axios({
        method: "POST",
        url: this.$SaveSalary,
        headers: this.getAuthHeader(),
        data: {
          company_id: this.selectedCompany.id,
          employee_id: this.employeeId.id,
          balance: this.payable,
          from_date: this.from_date,
          to_date: this.to_date,
          current_month_salary: (this.grossSalary()).toFixed(2),
        },
      }).then((res) => {
        $root.$toast.success(res.data.message);
        this.getEmployeeAttendanceWithSalary();
        this.getSalaryComponents();
        this.getSalaryComponentCalculations();
      });
    },

    saveSalaryComponentCalculation() {
      var fromDate = "";
      var toDate = "";

      fromDate = this.from_date;
      toDate = this.to_date;

      // Validate selected salary component
      if (!this.selectedComponent) {
        $root.$toast.error("Please select a salary component.");
        return; // Stop execution if component is not selected
      }

      // Validate balance amount
      if (!this.amount || isNaN(parseFloat(this.amount))) {
        $root.$toast.error("Please enter a valid amount.");
        return; // Stop execution if amount is invalid
      }
      this.saveSalary();
      this.$axios({
        method: "POST",
        url: this.$saveSalaryComponentCalculation,
        headers: this.getAuthHeader(),
        data: {
          company_id: this.selectedCompany.id,
          employee_id: this.employeeId.id,
          balance: this.payable,
          from_date: fromDate,
          to_date: toDate,
          amount: this.amount,
          type: this.selectedDC,
          salary_component: this.selectedComponent,
        },
      }).then((res) => {
        // Reset the input fields if needed
        this.selectedComponent = "";
        this.selectedDC = "Credit";
        this.amount = "";
        this.getSalaryComponentCalculations();
      });
    },

    updateSalaryComponentCalculation() {
      var fromDate = "";
      var toDate = "";
      fromDate = this.from_date;
      toDate = this.to_date;
      // Validate balance amount
      if (!this.amount || isNaN(parseFloat(this.amount))) {
        $root.$toast.error("Please enter a valid amount.");
        return; // Stop execution if amount is invalid
      }
      this.$axios({
        method: "PUT",
        url: this.$updateSalaryComponentCalculation,
        headers: this.getAuthHeader(),
        data: {
          company_id: this.selectedCompany.id,
          employee_id: this.employeeId.id,
          // balance: this.payable,
          from_date: fromDate,
          to_date: toDate,
          id: this.editableId,
          amount: this.amount,
          type: this.selectedDC,
          // salary_component: this.selectedComponent,
        },
      }).then((res) => {
        // Reset the input fields if needed
        this.selectedComponent = "";
        this.selectedDC = "Credit";
        this.amount = "";
        this.idEdit = false;
        this.getSalaryComponentCalculations();
      });
    },

    cancelUpdate() {
      this.idEdit = false;
      this.selectedComponent = "";
      this.selectedDC = "Credit";
      this.amount = "";
    },

    validateName() {
      // Reset errors
      this.nameError = false;
      this.duplicateError = false;

      // Check for non-alphabetic characters
      if (!/^[a-zA-Z\s]*$/.test(this.name2)) {
        // Add \s to allow spaces
        this.nameError = true;
      } else {
        // Check for duplicate names
        if (this.name.includes(this.name2.trim())) {
          this.duplicateError = true;
        }
      }
    },
    calculateTotalBalance() {
      let totalBalance = 0;
      for (let i = 0; i < this.empAttend.length; i++) {
        totalBalance += this.calculateBalance(i);
      }
      this.balance = totalBalance;
      return totalBalance;
    },

    calculateHoursM(startTime, endTime, date) {
      let time = this.calculateHourMinutes(
        moment(startTime).format("HH:mm"),
        moment(endTime).format("HH:mm"),
        moment(date).format("YYYY-MM-DD")
      );
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
    shouldShowMonth(index) {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based)

      // If logged-in user is a manager, show all months
      if ((this.user && this.user.type === 'MANAGER') || ( this.user.type === 'EMPLOYEE' && this.user.managerAccess == 'yes') ) {
        if (this.selectedYear === currentYear) {
          return index <= currentMonth; // Show only up to the current month
        }
        return true;
      }

      // If logged-in user is an employee, hide the current month
      if (this.user && this.user.type === 'EMPLOYEE' && this.user.managerAccess !== 'yes') {
        if (this.selectedYear === currentYear) {
          return index < currentMonth; // Hide current month
        }
      }

      return true; // Show all months for previous years
    },
    shouldShowMonth_old(index) {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();
      if (this.selectedYear === currentYear) {
        return index <= currentMonth; // Show only up to the current month
      }
      return true; // Show all months for previous years
    },
    onChange() {
      this.fullDayLeavesBalance = 0;
      this.payable = null;
      this.hoursNotFound = false;
      this.setDates();
      this.getEmployeeAttendanceWithSalary();
      this.getSalaryComponentCalculations();
      // this.getSalaryCalculation();
    },

    onYearChange() {
      this.fullDayLeavesBalance = 0;
      this.payable = null;
      this.hoursNotFound = false;
      this.setDates();
      // this.getSalaryCalculation();
    },

    setDates() {
      const year = this.selectedYear; // Get current year
      const daysInMonth = new Date(year, this.selectedMonth, 0).getDate(); // Get total days in the month
      // Set from_date to the first day of the month
      this.from_date = `${year}-${this.selectedMonth.toString().padStart(2, '0')}-01`;
      // Set to_date to the last day of the month
      this.to_date = `${year}-${this.selectedMonth.toString().padStart(2, '0')}-${daysInMonth}`;
    },

    getSalaryCalculation() {
      var params = {
        employee_id: this.employeeId.id,
        from_date: this.from_date,
        to_date: this.to_date,
        company_id: this.selectedCompany.id,
      };
      this.$axios
        .get(this.$getSalaryCalculation, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {

        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSalaryComponentCalculations() {
      var params = {
        employee_id: this.employeeId.id,
        from_date: this.from_date,
        to_date: this.to_date,
        company_id: this.selectedCompany.id,
      };
      this.$axios
        .get(this.$getSalaryComponentCalculation, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.salaryComponentCalculations = response.data.result;
          const salaryTax = this.salaryComponentCalculations.filter(salaryComponent => salaryComponent.salary_component === 'Tax');
          ;
          const tax = this.salaryComponents.filter(component => component.name === 'Tax');
          // console.log(tax.length)
          // if(tax.length == 0)
          // {
          //   this.name = ['Tax'];
          //   this.saveSalaryComponents();
          // }
          // if(this.employeeId.tax_amount > 0 && salaryTax.length == 0 && this.empAttend.length > 0)
          // {
          //   this.amount = this.employeeId.tax_amount
          //   this.selectedDC = 'Debit'
          //   this.selectedComponent = 'Tax'
          //   this.saveSalaryComponentCalculation();
          // }
          // Initialize sum to 0
          let sum = 0;

          // Loop through each calculation
          this.salaryComponentCalculations.forEach(calculation => {
            // If type is "Debit", subtract amount, otherwise add amount
            sum += calculation.type === "Credit" ? calculation.amount : -calculation.amount;
          });

          // Return the total sum with 2 decimal places
          this.salaryComponentCalculationsSum = sum.toFixed(2);
          this.loadingSpin = false;
          this.calculationNotFound =
            this.salaryComponentCalculations.length === 0 ? true : false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editSalaryCalculation(calculation) {
      this.idEdit = true
      this.amount = calculation.amount
      this.selectedComponent = calculation.salary_component
      this.selectedDC = calculation.type
      this.editableId = calculation.id
    },

    deleteSalaryCalculation(calculation) {
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Do you really want to delete this?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$axios({
            method: "POST",
            data: {
              id: calculation.id,
              company_id: this.selectedCompany.id,
              employee_id: this.employeeId.id,
            },
            url: this.$DeleteSalaryCalculation,
            headers: this.getAuthHeader(),
          }).then((res) => {
            if (res.data.status == 200) {
              this.idEdit = false
              // this.payable = this.payable
              //   ? this.payable
              //   : this.totalAmount();
              if (calculation.amount) {
                this.payable =
                  this.selectedDC === "Credit"
                    ? parseFloat(this.payable) + parseFloat(calculation.amount)
                    : parseFloat(this.payable) - parseFloat(calculation.amount);
              }
              if (res.data.result) {
                this.payable = res.data.result.balance;
              }
              this.getSalaryComponentCalculations();
              $root.$toast.success(res.data.message);
            }
          });
        }
      });
    },

    deleteSalaryComponent(id) {
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Do you really want to delete this?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$axios({
            method: "POST",
            data: {
              id: id,
              company_id: this.selectedCompany.id,
            },
            url: this.$DeleteSalaryComponent,
            headers: this.getAuthHeader(),
          }).then((res) => {
            if (res.data.status == 200) {
              this.getSalaryComponents();
              $root.$toast.success(res.data.message);
            }
          });
        }
      });
    },

    getEmployeeAttendanceWithSalary()
    {
      this.loadingSpin = true;
      this.newEmpAtt = [];
      var paramss = {
        company_id:  this.selectedCompany.id,
        employee_id: this.employeeId.id,
        from_date: this.from_date,
        to_date: this.to_date,
      };
     let url = this.$NewEmployeeAttendance
      this.$axios
      .get(url, {
          params: paramss,
          headers: this.getAuthHeader(),
        })
      .then((response) => {
          if (response.data.status == 200) {
            this.newEmpAtt = response.data.result;
            this.currentSalary=response.data.result.basic_salary
            if(response.data.result.salary_without_attendance==1){
              this.isWithoutAttendancePayableSalary=true;
              this.payable=response.data.result.basic_salary
            }
            if (Object.keys(this.newEmpAtt).length === 0) {
              this.loadingSpin = false;
              this.hoursNotFound = true;
            } else {
              this.loadingSpin = false;
              this.grossSalary();
            }
          }
        })
      .catch((error) => {
          console.log(error);
        });
    },
    getHoursByAttendanceAndShift3(attendance,schedule) {
      const punchInTime = new Date(attendance.punch_in_time);
      let punchOutTime = new Date(attendance.punch_out_time);
      const punchOutDateTime = moment(attendance.punch_out_time, "YYYY-MM-DD HH:mm:ss");
      const shiftDateTime = moment(schedule.date + ' ' + schedule.end_time, "YYYY-MM-DD HH:mm:ss");
      if (punchOutDateTime.isAfter(shiftDateTime)) {
        punchOutTime = new Date(shiftDateTime);
      }
      const timeDifference = punchOutTime - punchInTime;
      // Convert milliseconds to hours and minutes
      const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
      const totalMinutes = Math.round(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      // Combine hours and minutes
      // let punchInOutTotalHours = totalHours + totalMinutes / 100; cv
      let punchInOutTotalHours = totalHours + (totalMinutes / 60);

       // Get the shift hours including fractional hours
       const [startHour, startMinute] = schedule.start_time
        .split(":")
        .map(Number);
      const [endHour, endMinute] = schedule.end_time
        .split(":")
        .map(Number);

      // Convert hours and minutes to milliseconds
      const startTimeMillis = (startHour * 60 + startMinute) * 60 * 1000;
      const endTimeMillis = (endHour * 60 + endMinute) * 60 * 1000;

      const shiftTimeDifference = endTimeMillis - startTimeMillis;
      const shiftTotalHours = shiftTimeDifference / (1000 * 60 * 60); // Total hours including fractions

      // Calculate the total hours and minutes separately
      const totalShiftHours = Math.floor(shiftTotalHours); // Whole hours
      const totalShiftMinutes = Math.round(
        (shiftTotalHours - totalShiftHours) * 60
      ); // Remaining minutes
      let shiftTotal = Math.round(`${totalShiftHours}.${totalShiftMinutes}`);
      if (attendance.punch_out_time === null) {
        const now = new Date();
        const timeDifference = now - new Date(attendance.punch_in_time);
        const totalHours = timeDifference / (1000 * 60 * 60);
        const hours = Math.floor(totalHours);
        const minutes = Math.round((totalHours - hours) * 60);
        // Calculate the total time spent in decimal format
        const decimalTime = hours + minutes / 100;
        if (decimalTime > shiftTotal) {
          return shiftTotal
        } else {
          return decimalTime
        }
      }
      return punchInOutTotalHours;
    },

    grossSalary()
    {
      let hourlyRate = this.newEmpAtt.hourlyRate;
      let  grossPayAmount = 0;
      this.newEmpAtt.schedules?.forEach((item) => {
          item.attendances.forEach((attendance) => {
            // let hourCal=this.getHoursByAttendanceAndShift3(attendance, item);
            // let hourCal= this.convertTimeFormatIntoHoursMints(this.getHoursByAttendanceAndShift2(attendance, item)).toFixed(2);
            let CalculateAmountWithHourlyRateAndHours= this.calculateSalWithMinutes(hourlyRate,this.getHoursByAttendanceAndShift2(attendance, item));
            //console.log('hourCal',hourCal);
            // grossPayAmount += (hourlyRate * hourCal);
            grossPayAmount += CalculateAmountWithHourlyRateAndHours;
          });
        });
      if(this.isWithoutAttendancePayableSalary==true){
        grossPayAmount=parseInt(this.newEmpAtt.basic_salary)
      }
      this.payable = ((parseFloat(grossPayAmount) + parseFloat(this.salaryComponentCalculationsSum)).toFixed(2));
      return grossPayAmount;
    },

    getSalaryComponents() {
      var params = {company_id: this.selectedCompany.id};
      this.$axios
        .get(this.$getSalaryComponents, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.salaryComponents = response.data.result;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.mx-datepicker-range {
  width: 100% !important;
}

.dateBtn {
  color: #73879c !important;
}

.dateBtn:hover {
  color: #00779c !important;
}

.dateActive {
  color: #00779c !important;
}

#mapp {
  height: 500px !important;
}

.name-box {
  position: relative;
  background-color: #e2d7d7;
  padding: 10px 30px 10px 10px; /* Added padding for space for the close icon */
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.remove-label {
  position: absolute;
  top: -5px;
  right: -7px;
}

.close-icon {
  cursor: pointer;
  color: white;
}

.gg-backspace {
  color: black;
}

.gg-close-o {
  border: 2px solid #4b4747 !important;
  background-color: #000000 !important
}

.modelbody-name {
  color: black;
}

.payable-color {
  color: rgb(39, 36, 36);
}
</style>
